const ACCOUNT_0001 = 'ACCOUNT-0001'
const ACCOUNT_0002 = 'ACCOUNT-0002'
const ACCOUNT_0003 = 'ACCOUNT-0003'
const ACCOUNT_0004 = 'ACCOUNT-0004'
const ACCOUNT_0005 = 'ACCOUNT-0005'
const ACCOUNT_0006 = 'ACCOUNT-0006'
const ACCOUNT_0007 = 'ACCOUNT-0007'
const ACCOUNT_0008 = 'ACCOUNT-0008' // User already exists by <Email>
const ACCOUNT_0009 = 'ACCOUNT-0009'
const ACCOUNT_0010 = 'ACCOUNT-0010'
const ACCOUNT_0014 = 'ACCOUNT-0014' // User already exists by <shortSSN + DOB>
const ACCOUNT_IN_DNH = 'ACCOUNT_IN_DNH' // <Email> or <shortSSN + DOB> are in DNH list
const PASSWORD_0001 = 'PASSWORD-0001'
const PASSWORD_0002 = 'PASSWORD-0002'
const PASSWORD_0003 = 'PASSWORD-0003'
const PASSWORD_0004 = 'PASSWORD-0004'
const PASSWORD_0005 = 'PASSWORD-0005'
const PASSWORD_0006 = 'PASSWORD-0006'
const PASSWORD_0007 = 'PASSWORD-0007'

export const errorTypes = {
  ACCOUNT_0001,
  ACCOUNT_0002,
  ACCOUNT_0003,
  ACCOUNT_0004,
  ACCOUNT_0005,
  ACCOUNT_0006,
  ACCOUNT_0007,
  ACCOUNT_0008,
  ACCOUNT_0009,
  ACCOUNT_0010,
  ACCOUNT_0014,
  ACCOUNT_IN_DNH,
  PASSWORD_0001,
  PASSWORD_0002,
  PASSWORD_0003,
  PASSWORD_0004,
  PASSWORD_0005,
  PASSWORD_0006,
  PASSWORD_0007,
}
